import { File, Utilities } from "@@/elements/Icons/icons";
import Typography from "@@/elements/Typography";
import { TextcolorType } from "@@/elements/Typography/TypographyProps";
import cn from "classnames";
import styles from "./buttonStyles.module.scss";

export const scrollToSection = (link) => {
  const sectionId = link.split("#")[1];
  const targetElement = document.getElementById(sectionId);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: "smooth" });
  }
};

export const formatLinkContent = (href : string, label: string, target: string, textColor? : TextcolorType) => {
  const documentExtensions = /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|jpeg|jpg|png)(\?|#|$)/i;
  const match = href?.match(documentExtensions);
  const fileClasses = cn(styles.base_button_icon);


  if (match) { // Is document
    return (
          <>
            {<File height={20} width={20} className={fileClasses} />}
            {<Typography mx={2} textcolor={textColor} variant="button" asElement="span">{label}</Typography>}
          </>
        );
  }

  if (target === "_blank") {
    return (
      <>
        <Typography mr={2} pt={1} variant="button" textcolor={textColor} asElement="span">{label}</Typography>
        <Utilities height={20} className={styles.base_button_icon} width={20} />
      </>
    );
  }
    return (
    <Typography textcolor={textColor} variant="button">
      {label}
    </Typography>

    );
  };